import React from 'react';
import { func, number, string } from 'prop-types';
import debounce from 'lodash/debounce';
import './GeoDifferentialAdjustment.scss';
import Input from 'ps-components/Input/Input';

export class GeoDifferentialAdjustment extends React.Component {
  static propTypes = {
    jobFamily: string,
    location: string,
    totalAdjustment: number,
    totalAdjustmentOverride: number,
    updateTotalAdjustmentOverride: func
  };

  constructor(props) {
    super(props);
    this.state = {
      adjustmentOverride: this.formatAdjustment(props.totalAdjustmentOverride)
    };

    this.handleOverrideChange = this.handleOverrideChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.totalAdjustmentOverride !== this.props.totalAdjustmentOverride) {
      this.setState({ adjustmentOverride: this.formatAdjustment(this.props.totalAdjustmentOverride) });
    }
  }

  render() {
    const { jobFamily, location, totalAdjustment } = this.props;
    return (
      <div className="geo-adjustment">
        <span className="geo-adjustment__details">
          Reported Geo Differential{jobFamily ? ` for ${jobFamily}` : ''} in {location}
        </span>
        <span className="adjustment-percentage">{this.formatAdjustment(totalAdjustment)}</span>
        <span className="adjustment__label">Applied Geo Differential</span>
        <Input
          className="adjustment__input"
          id="geo_adjustment"
          onChange={this.handleOverrideChange}
          type="text"
          value={this.state.adjustmentOverride}
          disabled={false}
        />
      </div>
    );
  }

  formatAdjustment(adjustment) {
    return `${(adjustment * 100).toFixed(1)}%`;
  }

  handleOverrideChange(event) {
    const displayValue = event.target.value;
    const value = displayValue.replace('%', '');
    this.setState({ adjustmentOverride: displayValue });
    this.updateAdjustmentOverride(value);
  }

  updateAdjustmentOverride = debounce(value => {
    const { updateTotalAdjustmentOverride } = this.props;
    if (!isNaN(value)) {
      const decimalValue = parseFloat((value * 0.01).toFixed(3));
      updateTotalAdjustmentOverride(decimalValue);
      this.setState({ adjustmentOverride: this.formatAdjustment(decimalValue) });
    }
  }, 750);
}

export default GeoDifferentialAdjustment;
